import { type Person } from '@tmdb-graphql-api/schema/types';
import { encode } from 'js-base64';
import { type PersonOption } from '../types.ts';

export const buildDependencyKey = (values: Person[] | PersonOption[] | undefined) => {
  if (!values || values.length === 0) {
    return '';
  }

  return encode(values.map(value => value.id).join(','));
};
